import {Injectable} from '@angular/core';
import {AudioRecordModel} from '../audioRecord.model';
import {AudioRecordSummaryConverter} from './audioRecordSummary.converter';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {LovValueSummaryConverter} from '../../../../../lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class AudioRecordConverter extends HttpModelConverter<AudioRecordModel> {

    constructor(private audioRecordSummaryConverter: AudioRecordSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }
    protected createInstance(): AudioRecordModel {
        return new AudioRecordModel();
    }

    protected enrichObject(result: AudioRecordModel, src: AudioRecordModel) {
        result.summary = this.audioRecordSummaryConverter.convert(src.summary);
        result.contents = this.lovValueSummaryConverter.convertFromArray(src.contents);
    }
}
